import { useMutation } from '@apollo/client';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { Box, IconButton, styled, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';

import { usePortal } from '../../hooks/PortalProvider';
import { auctionIsLive, auctionIsPaused, lotIsLive } from '../../modules/portal';

import {
  PAUSE_AUCTION,
  RESUME_AUCTION,
} from '../../schema/portal';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0),
  padding: theme.spacing(0),
  color: theme.palette.light.main,
  '.MuiButtonBase-root': {
    fontSize: '1.75rem',
    color: theme.palette.background.lighterblue,
    margin: theme.spacing(0),
    padding: theme.spacing(0, 1),
  }
}));

const AdminTime = () => {
  const [time, setTime] = React.useState(new Date().toLocaleTimeString());
  const { activeLot, auction } = usePortal();
  const startedAt = auction?.portalInfo?.startedAt || null;

  const [pauseAuction] = useMutation(PAUSE_AUCTION);
  const [resumeAuction] = useMutation(RESUME_AUCTION);

  const toggleAuctionPause = () => {
    if (auctionIsPaused(auction)) {
      resumeAuction({ variables: { number: auction.number } });
    } else if (auctionIsLive(auction)) {
      pauseAuction({ variables: { number: auction.number } });
    }
  }

  React.useEffect(() => {
    if (!startedAt) {
      setTime(moment(new Date(auction?.date)).format('HH:mm [Uhr]'));
      return;
    }
    const timer = setInterval(() => {
      const elapsedMs = Math.max(0, Date.now() - new Date(startedAt).getTime());
      const duration = moment.duration(elapsedMs);
      const formattedTime = moment.utc(duration.asMilliseconds()).format('HH:mm:ss');

      setTime(`${formattedTime}`);
    }, 1000);
    return () => clearInterval(timer);
  }, [startedAt, auction?.date]);

  return (
    <StyledBox>
      <Typography variant="body1">
        {moment(new Date()).format('L')}
      </Typography>
      <Box
       sx={{
        display: 'flex',
        alignItems: 'center',
       }}
      >
        <Typography variant="h4">
          {time}
        </Typography>
        {auctionIsPaused(auction) || auctionIsLive(auction) ? (
          <IconButton
            disabled={lotIsLive(activeLot)}
            onClick={toggleAuctionPause}
          >
            {auctionIsPaused(auction)
              ? <PlayCircleOutlineIcon />
              : <PauseCircleOutlineIcon />}
          </IconButton>
        ) : null}
      </Box>
    </StyledBox>
  );
};

export default AdminTime;